<template>
  <Section
    :id="id"
    :header="t('manifests.manifests', 1)"
    class="manifest-section"
    data-class="flex flex-column flex-gap-1"
  >
    <ShipmentManifestLoadingCard v-if="manifest.loading" />
    <ShipmentManifestCard
      v-else-if="manifest.data?.id"
      :manifest="manifest.data"
    />

    <span v-else>
      {{ t('manifests.shipmentNotManifested') }}
    </span>
  </Section>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Loadable } from '@rygen/rygen-ui/model';

import { Manifest } from '@/model';

import ShipmentManifestCard from '@/components/shipment/manifest/ShipmentManifestCard.vue';
import ShipmentManifestLoadingCard from '@/components/shipment/manifest/ShipmentManifestLoadingCard.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  manifest: {
    type: Object as PropType<Loadable<Manifest>>,
    required: true,
  },
});
const { id, manifest } = toRefs(props);
const { t } = useI18n();
</script>
